import type React from 'react'

export interface NewDto {
    id: number
    title: string
    text: string
    creationDate: Date
}

export interface DeadLineDto {
    id: number
    dueDate: Date
    creationDate: Date
}

export interface CourseDto {
    title: string
    subtitle?: string
    subSubtitle?: string
    duration?: string
    price: string
    shortDescription: string
    description: React.ReactNode
    image: React.FC<React.SVGProps<SVGSVGElement>> | string
    smallText?: boolean
}

export type IconType = 'car' | 'motorcycle' | 'driving' | 'police' | 'custom'

export interface CourseApiDto {
    uuid: string
    title: string
    subtitle: string | null
    sub_subtitle: string | null
    duration: string | null
    price: string
    short_description: string
    description: string
    icon_type: IconType
    custom_image_url: string | null
    small_text: number
    sort_order: number
    created_at?: string
    updated_at?: string
}

export enum BEUrl {
    news = 'news',
    deadLine = 'deadLine',
    posts = 'posts',
    users = 'users',
    info = 'info',
    courses = 'courses',
}

export interface ServerResponse<T> {
    data: T[]
}
